<template>
  <div>
    <h1>Novo de Usuário</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("users", ["user"]),
  },
  methods: {
    ...mapActions("users", ["ActionNewUser"]),
    loadData(id) {
      this.$router.push({ name: "users_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewUser();
  },
};
</script>

<style></style>
